import classNames from 'classnames';
import * as React from 'react';
import { ButtonColor, ButtonType } from './models/ButtonModels';
import { getClassesForButtonColor, getClassesForButtonType } from './utils/buttonHelpers';

type SvgIconButtonProps = {
  Icon: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  buttonColor: ButtonColor;
  width: number;
  height: number;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  type?: ButtonType;
  buttonClasses?: string;
};

const SvgIconButton = (props: SvgIconButtonProps) => {
  const classes = classNames(
    getClassesForButtonType(ButtonType.Icon),
    getClassesForButtonColor(props.buttonColor),
    props.buttonClasses
  );

  return (
    <button className={classes} onClick={props.onClick}>
      <props.Icon width={props.width} height={props.height} />
    </button>
  );
};

export default SvgIconButton;
